import React from 'react';
import SelectedIntents from './selectedIntents.jsx';
import IntentsSelector from './intentsSelector.jsx';
import CmsService from '../js/cmsService.js';

let cmsService = new CmsService();

class UseCasesHeader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {sourceTypes: null, projectTypes: null, selectedProjects: [], selectedSources: []};
  }

  componentDidMount() {
    cmsService.getProjectTypes().then(projectTypes => {
      this.setState({projectTypes: projectTypes});
    });

    cmsService.getSourceTypes().then(sourceTypes => {
      this.setState({sourceTypes: sourceTypes});
    });
  }

  handleSourcesSelectionChanged = (selection) => {
    this.props.onIntentsChanged('SOURCES', selection);
  }

  handleProjectsSelectionChanged = (selection) => {
    this.props.onIntentsChanged('PROJECTS', selection);
  }

  handleBackButtonClicked = () => {
    this.props.onBack();
  }

  handleSkipLink = () => {
    this.props.onSkip();
  }

  render() {
    let headerContent;

    if(this.state.projectTypes && this.state.sourceTypes){

      const that=this;

      if (this.state.expanded) {
        headerContent = (<div key='2'>
          <IntentsSelector name='Connectors' intents={this.state.sourceTypes}
                           onSelectionChanged={this.handleSourcesSelectionChanged}
                           selectedIntents={this.props.selectedSources}/>
          <IntentsSelector name='Data Projects' intents={this.state.projectTypes}
                           onSelectionChanged={this.handleProjectsSelectionChanged}
                           selectedIntents={this.props.selectedProjects}/>
        </div>);

      } else {

        const selectedSources = this.props.selectedSources.map(function (tag) {
          return that.state.sourceTypes[tag];
        });

        const selectedProjects = this.props.selectedProjects.map(function (tag) {
          return that.state.projectTypes[tag];
        });
        headerContent = (
          <div key='1' className='use-case-header-selected-intents'>
            <SelectedIntents name='Connectors' selectedIntents={selectedSources}/>
            <SelectedIntents name='Data Projects' selectedIntents={selectedProjects}/>
          </div>
        );
      }
    }



    return (
      <div className='use-cases-header'>
        <div className='use-cases-header-top'>
          <a className='use-cases-back-button'
            onClick={this.handleBackButtonClicked}>&lt; { this.props.headerContent.back }</a>
          <span>{ this.props.title }</span>
          <a className='skip-link'
             onClick={this.handleSkipLink}>{ this.props.headerContent.skipTutorial }</a>
        </div>
      </div>
    );
  }
}

export default UseCasesHeader;


